/* eslint-disable no-new */
import * as types from './mutation-define'

const dialog_array = [
  'request',
  'destroy',
  'ship_out',
  'editvip',
  'saved_order',
  'take_cash',
  'shop_cost',
  'user_input',
  'pay_order',
  'user_pay',
  'active_tab',
  'left_sidebar',
  'vip_recharge'
]

const default_value ={
   'active_tab':0,
   // 'ship_out'  :'ship_out'
   // 'user_pay':'pay_order'
}


const state =  function(){
    let out_state = {
      user_input_fields :[]
    };
    dialog_array.map(dialog=>{
      out_state[`show_${dialog}_dialog`] = typeof(default_value[dialog])!='undefined'?default_value[dialog]:false;
    })
    return out_state
}()


// getters
const getters =  function(){
    let out_obj = {
      'user_input_fields' : state => state['user_input_fields']
    };
    dialog_array.map(dialog=>{
      out_obj[`show_${dialog}_dialog`] = state => state[`show_${dialog}_dialog`];
    })

    return out_obj
}()


const mutations =  function(){
    let out_obj = {};

    out_obj['user_input_fields'.toUpperCase()] = (state,val)=> {
       state['user_input_fields'] = val;
       state.show_user_input_dialog = true
    }

    dialog_array.map(dialog=>{
      let name = `SHOW_DIALOG_${dialog.toUpperCase()}`;
      out_obj[name] = (state,val) => {
        let state_nm = `show_${dialog}_dialog`;
        state[state_nm] = val;
        // if(name == 'SHOW_DIALOG_ACTIVE_TAB') debugger
        console.log(`MUTATIONS (${state_nm})=> ${name}:${val}`)
      }
    })
    return out_obj
}()

// mutations

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/dialog_store.js